import React from 'react';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';

function Form() {
    const pathFrontEnd = '/psp-arearoles/';
    const pathBackEnd = config.endpoints.backend + 'psp/arearoles/';

    const form = {
        labelTitleEdit: 'Editar Área de Atuação',
        labelTitleView: 'Visualizar Área de Atuação',
        labelTitleAdd: 'Nova Área de Atuação',
        pathView: pathFrontEnd + 'view',
        urlGoBack: pathFrontEnd + 'list',
        endpointGetById: pathBackEnd + 'getById',
        endpointSave: pathBackEnd + 'save',
        validateOnChange: true,
        fields: [
            {
                name: 'name',
                label: 'Nome da Área de Atuação',
                type: 'text',
                columnSize: 12,
                validations: {
                    required: true
                }
            }
        ]
    };

    return (
        <CustomFormContainer
            form={form}
            content={<CustomForm form={form} />}
        />
    );
}

export default Form;
